import { EmailSignatureItemResponse } from '../schema/EmailSignatureResponse';
import { EmailSignaturePreference } from '../schema/EmailSignaturePreference';

export const extractEmailSignaturePreference = (
    response: EmailSignatureItemResponse
): EmailSignaturePreference => response.data;
